import React, { useEffect, useState } from "react";
import styles from "./statistic.module.css";
import StatisticFormat from "components/statisticFormat/statisticFormat";
import { statistic8 } from "services/statistic/statistic8";
import { BlockmonthFacultyData } from "modules/statistic";
import { downloadFile, generateCSVContent, months } from "utils/statistic";
import Popup from "components/Popup/popup";
import ErrorFailed from "components/errorFailed/errorFailed";
import commonStyles from "components/commonStyle/commonStyle.module.css";


export default function Statistic8() {
  const [blockData, setBlockData] = useState<BlockmonthFacultyData>({});
  const [blocks, setBlocks] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minYear, setMinYear] = useState<number | null>(null);
  const [maxYear, setMaxYear] = useState<number | null>(null);
  const fetchData = async () => {
    try {
      const res = await statistic8(startDate, endDate);
      const { data, blocks, years } = res;
 
      setBlockData(data);
      setBlocks(blocks);
      setMinYear(Math.min(...years));
      setMaxYear(Math.max(...years));
    } catch (error) {
      console.error("Fehler beim Laden der Daten:", error);
    }
  };



  const handleFilter = () => {
    if (!startDate || !endDate) {
      setError("Bitte geben Sie sowohl ein Startdatum als auch ein Enddatum ein.");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      setError("Das Startdatum kann nicht nach dem Enddatum liegen.");
      return;
    }

    setIsPopupOpen(false);
    setError(null);
    setIsPopupOpen(false);
    fetchData();
  };

  const handleDeleteFilter = () => {
    setStartDate('');
    setEndDate('');
    setError(null)
    setIsPopupOpen(false);
  };

  const downloadCSV = () => {
    const headers = [
      'Monat/Jahr',
      ...blocks.map((block) => `Block ${block}`),
      'Gesamt',
      'davon U1',
    ];

    const rows: (string | number)[][] = [];

    allMonthsAndYears.forEach(({ month, year }) => {
      const yearData = blockData[month][year];

      const facultiesData = yearData.blocks.reduce((acc: { [faculty: string]: number }, block) => {
        Object.entries(block.faculties || {}).forEach(([faculty, count]) => {
          acc[faculty] = (acc[faculty] || 0) + count;
        });
        return acc;
      }, {});

      const row = [
        `${month} ${year}`,
        ...blocks.map((block) => {
          const blockDataForYear = yearData.blocks.find((b) => b.block === block);
          return blockDataForYear ? blockDataForYear.total_bookings : 0;
        }),
        yearData.total,
        yearData.under_one_year,
      ];
      rows.push(row);

      Object.entries(facultiesData).forEach(([faculty, totalFacultyBookings], index) => {
        const facultyRow = [
          faculty,
          ...blocks.map((block) => {
            const blockDataForYear = yearData.blocks.find((b) => b.block === block);
            return blockDataForYear && blockDataForYear.faculties && blockDataForYear.faculties[faculty]
              ? blockDataForYear.faculties[faculty]
              : 0;
          }),
          totalFacultyBookings,
        ];
        rows.push(facultyRow);
      });
    });

    const csvContent = generateCSVContent(headers, rows);
    downloadFile(csvContent, "Anlage4b.csv");
  };



  useEffect(() => {
    fetchData();
  }, [isPopupOpen]);

  const allMonthsAndYears: { month: string, year: string }[] = [];

  Object.entries(blockData).forEach(([month, yearData]) => {
    Object.keys(yearData).forEach((year) => {
      allMonthsAndYears.push({ month, year });
    });
  });

  allMonthsAndYears.sort((a, b) => {
    if (a.year !== b.year) {
      return Number(b.year) - Number(a.year);
    }
    return months.indexOf(b.month) - months.indexOf(a.month);
  });
  const allPossibleMonthYearCombinations: { month: string, year: string }[] = [];
  months.forEach(month => {
    const yearsInData = Object.keys(blockData[month] || {});
    yearsInData.forEach(year => {
      allPossibleMonthYearCombinations.push({ month, year });
    });
  });

  return (
    <>
      <StatisticFormat
        label="Anlage 4b"
        description={startDate && endDate
          ? `Belegungszahlen der "Flexi" im Zeitraum vom ${startDate} bis ${endDate} Anzahl der Buchungen je Block und Monat (Montag bis Freitag) nach Fakultäten.`
          : `Belegungszahlen der "Flexi" im Zeitraum vom 01.01.${minYear} bis 31.12.${maxYear} Anzahl der Buchungen je Block und Monat (Montag bis Freitag) nach Fakultäten.`
        }
        onFilterButton1Click={() => setIsPopupOpen(true)}
        onButton1Click={downloadCSV}
      >
        <div className={styles.container}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Monat/Jahr</th>
                {blocks.map((block) => (
                  <th key={`${block}-total`}>Block {block}</th>
                ))}
                <th className={styles.gesamt}>Gesamt</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.emptyRowNoBorder}>
                <td colSpan={blocks.length + 2}></td>
              </tr>

              {allMonthsAndYears.filter((rec) => rec.year)
                .map(({ month, year }) => {
                  const yearData = blockData[month][year];
                  const facultiesData = yearData.blocks.reduce((acc: { [faculty: string]: number }, block) => {
                    Object.entries(block.faculties || {}).forEach(([faculty, count]) => {
                      acc[faculty] = (acc[faculty] || 0) + count;
                    });
                    return acc;
                  }, {});
                  return (
                    <React.Fragment key={`${month}-${year}`}>
                      <tr key={`${month}-${year}`} className={styles[`year-${(new Date().getFullYear() - parseInt(year)) % 9 + 1}`]}>
                        <td>{month} {year}</td>
                        {blocks.map((block) => {
                          const blockDataForYear = yearData.blocks.find((b) => b.block === block);
                          return (
                            <td key={`${month}-${year}-${block}-total`}>
                              {blockDataForYear ? blockDataForYear.total_bookings : 0}
                            </td>
                          );
                        })}
                        <td>{yearData.total}</td>
                      </tr>

                      <tr key={`${month}-${year}-under-one`} className={styles[`year-${(new Date().getFullYear() - parseInt(year)) % 9 + 1}`]}>
                        <td>davon U1</td>
                        {blocks.map((block) => {
                          const blockDataForYear = yearData.blocks.find((b) => b.block === block);
                          return (
                            <td key={`${month}-${year}-${block}-under-one`} >
                              {blockDataForYear ? blockDataForYear.under_one_year : 0}
                            </td>
                          );
                        })}
                        <td>{yearData.under_one_year}</td>
                      </tr>

                      {Object.entries(facultiesData).map(([faculty, totalFacultyBookings], index) => (
                        <tr key={`${month}-${year}-faculty-${faculty}`} className={styles[`year-${index % 9 + 1}`]}>
                          <td>{faculty}</td>
                          {blocks.map((block) => {
                            const blockDataForYear = yearData.blocks.find((b) => b.block === block);
                            return (
                              <td key={`${month}-${year}-${block}-faculties-${faculty}`}>
                                {blockDataForYear && blockDataForYear.faculties && blockDataForYear.faculties[faculty]
                                  ? blockDataForYear.faculties[faculty]
                                  : 0}
                              </td>
                            );
                          })}
                          <td>{totalFacultyBookings}</td>
                        </tr>
                      ))}
                      <tr className={styles.emptyRowNoBorder}>
                        <td colSpan={blocks.length + 2} key={`empty-row-${month}-${year}`}></td>
                      </tr>
                    </React.Fragment>
                  );
                })}


            </tbody>
          </table>
        </div>
      </StatisticFormat>
      <Popup
        title={'Filter'}
        submitLabel={"Einsetzen"}
        closeLabel={"Zurücksetzen"}
        isWithButton={true}
        isOpen={isPopupOpen}
        onClose={handleDeleteFilter} onSubmit={handleFilter}>
        {error && <ErrorFailed error={error} />}

        <div className={commonStyles.formGroupRow}>
          <div className={commonStyles.formGroup}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className={commonStyles.formGroup}>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </Popup>
    </>
  );

}
